import { render, staticRenderFns } from "./EnterBtn.vue?vue&type=template&id=ba1fc9a4&"
import script from "./EnterBtn.vue?vue&type=script&lang=js&"
export * from "./EnterBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports